import { useQuery } from "@tanstack/react-query";
import { getProjects } from "../../services/apiProjects";

/**
 * Loads all projects.
 *
 * @returns {{ isLoading: boolean, projects: Array<object> | undefined, error: unknown }} Query state and projects.
 */
export function useProjects() {
    const {
        isLoading,
        data: projects,
        error,
    } = useQuery({
        queryKey: ["projects"],
        queryFn: getProjects,
    });

    return { isLoading, projects, error };
}
